import { Box, Button, IconButton, Typography, styled, useTheme } from "@mui/material";

import { StockMarket, TransferData } from "assets/Icon";
import useIsMobileView from "hooks/useIsMobileView";

function TradeHead({
  setShowMarketDrawer,
  hideActions = false,
  coinMarketDetails,
  handleShowOrHideTradingView
}) {
  const isMobileView = useIsMobileView()
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box display="flex">
        {hideActions ? (
          <Box display="flex" alignItems="center" py={1.5} px={1}>
            <Typography color="text.main" variant="h3" component="span">
              {coinMarketDetails?.coinSourceName}{" "}
            </Typography>{" "}
            <Typography color="text.main" component="small" fontWeight={300}>
              /{coinMarketDetails?.coinDestinationName}
            </Typography>
          </Box>
        ) : (
          <ButtonStyle
            variant="text"
            color="text"
            onClick={() => setShowMarketDrawer(true)}
          >
            <TransferData color={theme.palette.text.main} />
            <Typography variant="h3" component="span">
              {coinMarketDetails?.coinSourceName}{" "}
            </Typography>{" "}
            <Typography component="small" fontWeight={300}>
              /{coinMarketDetails?.coinDestinationName}
            </Typography>
          </ButtonStyle>
        )}
      </Box>

      {isMobileView && (
        <IconButton color="text" onClick={() => handleShowOrHideTradingView && handleShowOrHideTradingView()}>
          <StockMarket color={theme.palette.text.main} />
        </IconButton>
      )}
    </Box>
  );
}

const ButtonStyle = styled(Button)(({ theme }) => ({
  svg: {
    fontSize: "24px",
    marginRight: "6px",
  },
}));

export default TradeHead;
